import React from "react";
import { Link, useParams } from "react-router-dom";
import PageLayout from "../components/pageLayout";
import HtmlContent from "../components/HtmlContent";
import { useSiteData } from "../lib/siteApi";

export default function CmsPage() {
  const { slug } = useParams();
  const site = useSiteData();
  const item = (site.pages || []).find((page) => page.slug === slug) || null;
  const to = `/pages/${slug || ""}`;
  const related = (site.pages || []).filter((page) => page.slug !== slug).slice(0, 3).map((page) => ({
    to: `/pages/${page.slug}`,
    title: page.title,
    image: page.imageUrl,
    kicker: "Page",
  }));

  return (
    <PageLayout
      eyebrow="RENERG"
      title={item?.title || "Page"}
      image={item?.imageUrl}
      crumbs={[{ label: item?.title || "Page" }]}
      related={related}
    >
      {!item ? (
        <p className="text-slate-500">Page not found. <Link to="/" className="font-semibold text-teal-700">Back home</Link></p>
      ) : (
        <article className="max-w-4xl rounded-3xl bg-white p-8 shadow-lg lg:p-12">
          <div className="text-lg text-slate-600 leading-relaxed">
            <HtmlContent html={item.body} imageTo={to} />
          </div>
        </article>
      )}
    </PageLayout>
  );
}
